module.exports = " <div> <label>{{label}} <a href=# v-clap.prevent=setNow()>set to now</a></label> <input v-el:date type=datetime-local v-model=value data-input> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/DateTime.vue
// module id = 96
// module chunks = 2